import { apiService, getController } from '@/services/service'

const url = 'syncs'

export interface SyncInstallerDownload {
	url: string
}

export const syncService = {
	...getController<Api.Sync>(url),
	/**
	 * Returns the address of the legacy sync installer bundle
	 * (AAR-1362 / AAR-1859 / AAR-1860). The address itself is public and stable —
	 * the datendienst resolves the currently released build on every request, so
	 * it always serves the current version. What this call decides is not the
	 * address but the entitlement: the API only answers for an admin of a tenant
	 * that is actually outdated, and only once the rollout gate is open.
	 * Fetched on click rather than on load so a page view costs no request.
	 * `silentError` keeps the global error dialog/redirect out of the way —
	 * the banner shows its own inline message instead.
	 */
	installerDownload: () =>
		apiService.get<SyncInstallerDownload>({
			url: 'sync/installer-download',
			meta: { silentError: true },
		}),
}

export default syncService
